import type { TO_ListData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTOListData: Omit<TO_ListData, 'selectedVariable'> = {
  title: 'Default List Title',
  viewType: 'List Compact'
};
